// Minimal service-worker registration utility.
// Registers /service-worker.js (served from public/) in production builds only,
// and on the same origin. Offers a one-line interface used by index.js / App.
//
// Why production-only? Dev/HMR + SW caching can cause stale builds and confusing
// behaviour. The PWA install prompt still requires HTTPS, which the deployed
// build (sent-i-meter.com) satisfies.

const isLocalhost = Boolean(
  typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
      window.location.hostname === "[::1]" ||
      /^127(?:\.\d{1,3}){3}$/.test(window.location.hostname))
);

export function register() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;
  if (isLocalhost) return;

  window.addEventListener("load", () => {
    const swUrl = "/service-worker.js";
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        // Reload once a new SW takes control so users get the latest build.
        if (reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
        reg.addEventListener("updatefound", () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // Newer SW ready; tell it to activate immediately.
              installing.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch((err) => {
        // Silently ignore — SW is a progressive enhancement.
        // eslint-disable-next-line no-console
        console.debug("SW registration skipped:", err?.message);
      });

    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}

export function unregister() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker.ready
    .then((reg) => reg.unregister())
    .catch(() => {});
}
